import React, { useEffect } from 'react';
import { Col, Row, Container } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import ReadMore from '../components/ReadMore';
import credibleCertification from '../../assets/images/credibleCertification.png';
// import credibleStats1 from '../../assets/images/credibleStats1.png';
// import credibleFoundations from '../../assets/images/credibleFoundations.png';
// import credibleMemberSurvey2 from '../../assets/images/credibleMemberSurvey2.png';
// import credibleMemberSurvey1 from '../../assets/images/credibleMemberSurvey1.png';
import CommunicationsHighlights from './components/CommunicationsHighlights';
import ScrollToTop from '../components/ScrollToTop';

import ADecadeGraphics from './components/ADecadeGraphics.js';
import ELearningHighlights from './components/ElearningHighlights';
import DataStandards from './components/DataStandards';
import LevelsGraphic from './components/LevelsGraphic';
import MemberSurvey from './components/MemberSurvey';

const CollaborationPage = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo isMobile={isMobile}>
      {/* <div className="backgroundRectangle" style={{
            position: 'absolute',
            height: 1200,
            width,
            zIndex: -1
          }} />
          <div className="backgroundArrow" style={{
        position: 'absolute',
        height: 3400,
        width,
        zIndex: -1
      }} /> */}
      <Row>
        <Col>
          <h2 style={{ marginTop: 120 }}>
            CREDIBLE
          </h2>
          <p style={{ marginTop: 30 }}>
            CSIO invests continuously in innovation and programs. Members know they can count on those same innovations and programs to keep them informed. They trust CSIO for the best information and solutions.
          </p>
          <p>
            Thanks to that trust, members have embraced certification on Data Standards, eDocs and are now becoming Digital Members. This year, more than ever, they made the most of eLearning. Online, the conversations were humming, and we kept information moving with articles, press releases and social posts.
                              </p>
          <p>
            All of it adds up to trust and solid thought leadership.
          </p>
          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="certification" tabIndex="-1">
            CERTIFICATION
          </h3>
          <p style={{ marginTop: 30 }}>
            Data Standards are the cornerstone of all of our activities. The certification programs that surround these Data Standards allow insurers and vendors to demonstrate they are sharing policy information and data in the most seamless, efficient way. It gives them a competitive advantage with brokers – and lets brokers give the best customer service.
          </p>
          <h4 style={{ marginTop: 60, textAlign: 'center', marginBottom: 60 }}>
            CSIO’S Certification Options Keep Growing
          </h4>
          <DataStandards />
          <h3 style={{ marginTop: 60, textAlign: 'center' }}>
            COMMERCIAL LINES CERTIFICATION PROGRAM
                    </h3>
          <Container fluid>
            <Row style={{
              // display: 'flex',
              // flexDirection: 'row',
              marginTop: 30,
              marginBottom: 60
            }}>
              <Col xs={12}
                // sm={6} md={4} style={width < 576 ? {display: 'flex', justifyContent: 'center', alignItems: 'center'} : null}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <img
                className="zoom"
                  src={credibleCertification}
                  style={{
                    width: 600,
                    height: 'auto',
                    // padding: 60,
                    margin: 40,
                  }}
                  aria-label="Level 1, Foundation. Commit to the journey of being an effective and efficient commercial lines partner by implementing the minimum data set. Leveraging CSIO XML Standards, this sets the foundation for real-time quoting. Level 2, verified. Build upon the minimum data set to demonstrate the successful exchange of data between insurance partners in test scenarios. Level 3, certified. Launch real-time quoting functionality to brokers for at least one segment of small business, highlighting the value and efficiency of straight-through processing."
                />
              </Col>
              <Col xs={12}
              // sm={6} md={8}

              >
                <p>
                  Spurred by the Commercial Lines (CL) Working Group’s headway in 2019, we launched the CL Certification Program in April 1. Applicants need to work through each of three phases of certification. Each milestone requires the applicant to meet a set of criteria before they can move to the next level.
</p>
                <p>
                  Insurers and vendors were so eager to be certified, we had our first Level II certification within a month. CSIO is pleased to recognize these certified insurers and vendors as innovative leaders.
</p>
              </Col>
            </Row>
          </Container>
          <LevelsGraphic />
          <h3 
          id="certification"
          tabIndex="-1"
          style={{ marginTop: 60, textAlign: 'center', textTransform: 'none' }}>
            eDOCS CERTIFICATION
                    </h3>
          <p style={{ marginTop: 30 }}>
            The CSIO eDocs Data Standard allow downloading documents directly from an insurer’s system to a broker management system, via CSIOnet. eDocs are standardized, so insurers and brokers structure their data in the agreed-upon rules. That means any software can read and store that data.
                    </p>
          <h4 style={{ marginTop: 30, textAlign: 'center', marginBottom: 30 }}>
            A Decade With eDocs – and Still Growing Strong
            </h4>
          <ADecadeGraphics />
          <p style={{ marginTop: 30 }}>
            See a list of members <a className="detailsLink" aria-label="Navigate to pdf of members list in a new tab" href="https://www.csio.com/resources-tools/csio-certification/certified-members" target="_blank" rel="noreferrer">here</a> who have made the commitment to eDocs certification.
          </p>
          <h3 
          id="eLearning"
          tabIndex="-1"
          style={{ marginTop: 60, textAlign: 'center', textTransform: 'none' }}>
            eLEARNING
                    </h3>
          <p style={{ marginTop: 60 }}>
            Members have always embraced our online learning opportunities. But 2021 was a year like no other. With the sudden pandemic measures in March, the industry was faced with cancellation or postponement of all conventions and in-person learning.
</p>
          <p style={{ margin: 0 }}>
            eLearning met member demand for:
</p>
          <ul style={{ marginTop: 0, marginBottom: 10 }}>
            <li className="credibleLi">
              free, accredited distance learning to help build their digital competencies
  </li>
            <li className="credibleLi">
              brokers obtaining continuing education (CE) credits and carrying on with updating their skills and learning
  </li>
            <li className="credibleLi">
              education on adopting digital solutions – from eSlips, eSignatures and document delivery that is critical for insurance businesses
  </li>
          </ul>
          <ReadMore title="Watch video to learn more about our eLearning program" asA href="https://www.csio.com/resources-tools/elearning" target="_blank" rel="noreferrer" />
          <h4 style={{ marginTop: 60, textAlign: 'center', marginBottom: 40 }}>
            eLearning Highlights
            </h4>
          <ELearningHighlights />
          <h3 style={{ marginTop: 60, textAlign: 'center' }}>
            GETTING THE WORD OUT
                    </h3>
          <p style={{ marginTop: 30 }}>
            Amid the pandemic, insurance operations had to continue, but with reduced face-to-face interaction. Taking the annual meeting and other events online made staying in touch with our members via external communications more important than ever.
</p>
          <p>
            We continued to get the word out with regular articles in trade and provincial association publications. Meanwhile, our social channels were buzzing with consumer content and conversation, extending the reach of our web and email channels. Members told us through actions, rather than words, that our communications were in demand, as our email distribution list expanded and website traffic was strong.
</p>
          <h4 style={{ marginTop: 60, textAlign: 'center', marginBottom: 60 }}>
            Communications Highlights
            </h4>
            <CommunicationsHighlights />
          <h3 style={{ marginTop: 60, textAlign: 'center' }}>
            MEMBER SURVEY
                    </h3>
          <p style={{ marginTop: 30 }}>
            CSIO has been conducting its member survey every two years since 2015. In 1, we made the shift to an annual survey to let us monitor trends more closely and give members another opportunity for timely feedback.
                    </p>

          <div style={{
            fontFamily: 'Montserrat SemiBold',
            color: '#1B526D',
            letterSpacing: .5,
            fontSize: 20,
            marginTop: 30
            // lineHeight: 27
          }}>
            What Did CSIO Members Tell us in 2021?
                    </div>

          <ul>
            <li className="credibleLi">
              Overwhelmingly, they are satisfied with CSIO’s work, solutions, services and resources
                      </li>
            <li className="credibleLi">
              More than ever, members believe their business is a digital business, and they are digitally astute themselves.
                      </li>
          </ul>

          <MemberSurvey />

          <p style={{ margin: 0, marginTop: 60, }}>
            CSIO’s strategic priorities align with what the industry wants us to work on:
          </p>
          <ul>
            <li className="credibleLi">
              Enhancing core services
            </li>
            <li className="credibleLi">
              Advancing commercial lines Data Standards
            </li>
            <li className="credibleLi">
              Delivering new, innovative solutions
            </li>
            <li className="credibleLi">
              Achieving paperless and digital transformation in the broker channel
            </li>
          </ul>
          <h4 style={{ marginTop: 60, textAlign: 'center' }}>
            We thank members for taking the time to complete the survey and look forward to hearing from them again in 2021.
            </h4>

        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH}/>
    </PageWrapper>
  )
}

export default CollaborationPage;
